export const fileTypeImage = ["image/png", "image/jpeg"];
